import { getRecoil, setRecoil } from "recoil-nexus";

import mainStore from "src/stores/main";
import upperDataStore from "src/stores/upperData";
import { BetTypeEnum } from "src/constants/enums/betType";
import { PriceChangeEnum } from "src/constants/enums/priceChange";

export const resetBetslip = () => {
    const { config } = getRecoil(upperDataStore);

    setRecoil(mainStore, mainState => ({
        ...mainState,
        stake: '' as const,
        lastBetStake: mainState.stake,
        betType: BetTypeEnum[config.defaultBetType],
        priceChangeType: PriceChangeEnum[config.defaultPriceChangeType],
        editingBet: null,
        verificationDisabledManually: false,
        isFreeBetEnabled: false,
        freeBets: [],
        // profitBoost: null,
    }));
};
